import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductQuantityOrdered from "@insite/content-library/Components/ProductQuantityOrdered";
import { TextFieldProps } from "@insite/mobius/TextField";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

// Store Custom Code
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { TYPOGRAPHY } from "@store/theme/design";

type Props = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState, ownProps: HasProduct) => ({
    configurationSelection: state.pages.productDetails.configurationSelection,
    configurationCompleted: state.pages.productDetails.configurationCompleted,
    variantSelectionCompleted: state.pages.productDetails.variantSelectionCompleted,
});

export interface ProductDetailsQuantityOrderedStyles {
    quantityOrdered?: TextFieldProps;
}

export const quantityOrderedStyles: ProductDetailsQuantityOrderedStyles = {
    quantityOrdered: {
        cssOverrides: {
            // Store Custom Code
            formField: css`
                input {
                    padding: 0 8px !important;
                    width: 50px !important;
                    color: #000 !important;
                    height: 45px;
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                width: 100%;
                                display: inline-block;
                                margin-right: 2%;
                                padding: 0 5px;
                                float: right;
                                font-size: ${TYPOGRAPHY.size.smaller};
                                height: 54px;
                            `,
                            css``,
                            css`
                                float: none;
                                display: inline-block;
                            `,
                            css``,
                            css``,
                        ],
                        "min",
                    )}
            `,
        },
        label: null,
    },
};

const styles = quantityOrderedStyles;

const ProductDetailsQuantityOrdered = ({
    configurationSelection,
    configurationCompleted,
    variantSelectionCompleted,
}: Props) => {
    return (
        <ProductQuantityOrdered
            configurationSelection={configurationSelection}
            configurationCompleted={configurationCompleted}
            variantSelectionCompleted={variantSelectionCompleted}
            extendedStyles={styles.quantityOrdered}
        />
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(connect(mapStateToProps)(ProductDetailsQuantityOrdered)),
    definition: {
        displayName: "Quantity Ordered",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
